import {
  GET_LIST_CAUHINHGOITRAGOP,
  GET_LIST_CAUHINHGOITRAGOP_SUCCESS,
  GET_LIST_CAUHINHGOITRAGOP_FAILURE,
} from "../../../actions/CauHinhGoiTraGop/actionTypes";
import moment from "moment";

const initialState = {
  List: [],
  iTotal: 0,
  isStartProcess: false,
};

const getListCauHinhGoiTraGop = (state, action) => ({
  ...state,
  isStartProcess: true,
});

const getListCauHinhGoiTraGopSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    iTotal: action.payload.iTotal,
    isStartProcess: false,
  };
};

const getListCauHinhGoiTraGopFailed = (state, action) => ({
  ...state,
  isStartProcess: false,
  List: [],
});

export const listCauHinhGoiTraGopReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CAUHINHGOITRAGOP:
      return getListCauHinhGoiTraGop(state, action);
    case GET_LIST_CAUHINHGOITRAGOP_SUCCESS:
      return getListCauHinhGoiTraGopSuccess(state, action);
    case GET_LIST_CAUHINHGOITRAGOP_FAILURE:
      return getListCauHinhGoiTraGopFailed(state, action);
    default:
      return state;
  }
};

export default listCauHinhGoiTraGopReducer;
